/**
 * axios配置文件
 *
 * @date 2019-04-29
 * @author chenyongzheng
 */

// 引入vue
import Vue from 'vue';

// 引入axios
import axios from 'axios';

// 引入elementUI MessageBox模块 Message模块
import {MessageBox, Message, Loading} from 'element-ui'

// 配置baseURL
const serverAddress = {
    // 生产环境服务器地址
    //production: 'http://1.28.126.162:9999',
    // production: 'http://210w942o13.imwork.net',
    production: 'https://556.jettylee.cn/api',
    // 开发环境服务器地址 //TODO 对接口时 添加后缀
    // development: 'http://127.0.0.1:8080/ErpProduct',
    // development: 'http://127.0.0.1:9999',
    development: 'https://556.jettylee.cn/api',
    // development: 'http://210w942o13.imwork.net',
    // development: 'http://1.28.126.162:9999',
};
// 通过 process.env.NODE_ENV 来判断当前运行环境
axios.defaults.baseURL = serverAddress[process.env.NODE_ENV];
// 允许携带cookie
axios.defaults.withCredentials = true;
// 创建axios
let instance = axios.create();
// 超时 50000
instance.defaults.timeout = 50000;

// 加载modal
let loading;
// 拦截所有请求
axios.interceptors.request.use((request) => {
    // 如果包含本地测试数据的请求地址
    // if ('test-json-data'.indexOf(request.url)) {
    //     // 将本次请求的 baseURL 临时替换 在static文件下编辑测试数据
    //     request.baseURL = 'http://localhost:8080/static';
    //     return request;
    // }
    if ('/admin/login'.indexOf(request.url)) {
        // 将本次请求的 baseURL 临时替换 在static文件下编辑测试数据
        return request;
    }
    // // 除登录的请求地址以外所有请求都添加 account_token;
    // // 从localStorage中获取token 登录时存入的
   let token = Vue.prototype.$localStorage.getItem('token');
    // // 在请求头中加入token
    request.headers.Authorization = 'Bearer ' + token;

    // 加载
    loading = Loading.service({fullscreen: true, text: "数据正在加载中···"});
    // 返回请求
    return request;
}, (err) => {

    // 返回请求异常
    return Promise.reject(err);
});

// 拦截所有响应
// TODO 稍后对接后台接口时 优化此处向下代码
let flag = true;
axios.interceptors.response.use((response) => {
    // 关闭加载
    if (loading) {
        loading.close();
    }

    if (response.data instanceof Blob) {
        return Promise.resolve(response.data || response);
    }

    // 返回状态码
    let statusCode = response.data.status;

    switch (statusCode) {
        case 200:
            return response.data;
        case 2000:
            // 返回响应
            return response.data.data;
        case 9999:
            Message({
                message: res.data.msg || 'error',
                type: 'error',
                duration: 5 * 1000
            });
            return Promise.reject(res.data.msg || 'error');
        case 5000:
            MessageBox.alert('帐号密码错误，请重新登录', '登录失败', {
                confirmButtonText: '确定',
                callback: action => {
                    Vue.prototype.$localStorage.removeItem('token');
                    Vue.prototype.$localStorage.removeItem('ident');
                    Vue.prototype.$localStorage.removeItem('SET_ROUTERS');
                    window.location.href = '/';
                }
            });
            break;
        default:
           let res = Object.assign(response.data.data, {"status":response.data.data.status});
            return res;
    }

}, (err) => {
    // 关闭加载
    if (loading) {
        loading.close();
    }
    switch (err.response.status) {
        case 500:
            // 返回响应
            return Promise.reject('服务器有点忙,请稍后重试' || 'error');

        default:
            return Promise.reject(err);
    }
    // 返回响应异常

});

// 挂载到 Vue原型链
Vue.prototype.$axios = axios;



// WEBPACK FOOTER //
// ./src/utils/axios.js